
import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import './UploadFileItem.css'
import { IconPlus } from '@tabler/icons-react'

const UploadFileItem = ({ handleClick, hiddenFileInput, handleChange, files, filesPreview, index, style, handleDelete, total }) => {
  // const fileType = (type) => {
  //   switch (type) {
  //     case 'image/jpeg':
  //       return icon({ name: 'file-image' })
  //     case 'application/pdf':
  //       return icon({ name: 'file-pdf' })
  //     default:
  //       return icon({ name: 'file' })
  //   }
  // }

  return (
    <div style={style}>
      <Button className='upload' onClick={handleClick}>
        {files[index] && files[index].type !== 'application/pdf' ? (
          <img
            src={filesPreview[index]}
            alt=''
            style={{
              width: '100%',
            }}
          />
        ) : (
          <IconPlus
            style={{
              opacity: files[index] ? 1 : 0.2,
            }}
            // icon={files[index] ? fileType(files[index].type) : icon({ name: 'plus' })}
            size={32}
            color='#285843'
          />
        )}
      </Button>
      <input type='file' disabled={files?.length === total} ref={hiddenFileInput} onChange={handleChange} style={{ display: 'none' }} />
      <div>
        {files?.length > 0 && files[index] ? (
          <Button
            color='danger'
            block
            size={20}
            style={{
              marginTop: '0.5rem',
              paddingTop: 0,
              borderRadius: '50px',
              fontSize: '0.7rem',
              height: '1.1rem',
            }}
            onClick={handleDelete}
          >
            Sil
          </Button>
        ) : null}
      </div>
    </div>
  )
}

UploadFileItem.propTypes = {
  hiddenFileInput: PropTypes.object,
  handleClick: PropTypes.func,
  handleChange: PropTypes.func,
  files: PropTypes.array,
  filesPreview: PropTypes.array,
  index: PropTypes.number,
}

export default UploadFileItem
